// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShrinkOutlinedSvg from "@fishx/icons-svg/es/asn/ShrinkOutlined";
import FishxIcon from '../components/FishxIcon';

var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShrinkOutlinedSvg
  }));
};

ShrinkOutlined.displayName = 'ShrinkOutlined';
export default React.forwardRef(ShrinkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShrinkOutlined.js
// module id = 4118
// module chunks = 0